import {
	REQUEST_PRODUCTION_STEPS_STATS,
	RECEIVE_PRODUCTION_STEPS_STATS,
	PRODUCTION_STEPS_STATS_ERROR
} from "../actions/productionStepsStatsActions";

const initialProductionStepsStatsState = {
	isFetching: false,
	items: {},
	error: null
};

export const productionStepsStatsReducer = (state = initialProductionStepsStatsState, action) => {
	switch (action.type) {
		case REQUEST_PRODUCTION_STEPS_STATS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true };
		case RECEIVE_PRODUCTION_STEPS_STATS:
			// reduced the provided array to an object with oderIds as keys and orders as values
			const mypayload = action.payload.reduce((accumulator, order) => {
				return { ...accumulator, [order._id]: order.orders };
			}, {});
			return { ...state, items: mypayload, isFetching: false };
		case PRODUCTION_STEPS_STATS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		default:
			return state;
	}
};
